import React from 'react';

export const GooglePlusIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8203 0.212402C12.0132 0.212402 0.820312 11.4053 0.820312 25.2124C0.820312 39.0195 12.0132 50.2124 25.8203 50.2124C39.6274 50.2124 50.8203 39.0195 50.8203 25.2124C50.8203 11.4053 39.6274 0.212402 25.8203 0.212402ZM19.748 27.2874H25.4733C24.6375 29.6154 22.387 31.2874 19.748 31.2874C16.4006 31.2874 13.6765 28.5954 13.6765 25.2874C13.6765 21.9794 16.4006 19.2874 19.748 19.2874C21.199 19.2874 22.5955 19.8014 23.6802 20.7354L26.3395 17.7194C24.5181 16.1514 22.1785 15.2874 19.748 15.2874C14.1683 15.2874 9.62891 19.7734 9.62891 25.2874C9.62891 30.8014 14.1683 35.2874 19.748 35.2874C25.3276 35.2874 29.867 30.8014 29.867 25.2874V23.2874H19.748V27.2874ZM37.9622 23.2874V19.2874H35.9384V23.2874H31.8908V25.2874H35.9384V29.2874H37.9622V25.2874H42.0099V23.2874H37.9622Z"
      fill="#F1F2F3"
      fillOpacity="0.31"
    />
  </svg>
);
